import React from "react";

const FullScreenLoader = ({ theme = "light" }) => {
  const spinnerColor =
    theme === "light"
      ? "border-gray-300 border-t-blue-500"
      : "border-gray-700 border-t-white";

  return (
    <>
      <div className="flex-col absolute top-0 left-0 w-full h-full backdrop-blur-sm flex justify-center items-center z-50">
        <div
          className={`w-16 h-16 border-4 rounded-full animate-spin ${spinnerColor}`}
        ></div>
        <h1 className="text-white">Please wait...</h1>
      </div>
    </>
  );
};

export default FullScreenLoader;
